import React, { useState } from "react";
import { ISearchContext, SearchContextProvider, useSearch } from "./SearchContext";

export interface ILiveFiltersProps {
  flexBoxColWidth?: string;
  fieldColClass?: string;
  standardFilters?: (context: ISearchContext) => React.ReactNode;
  orFilters?: (context: ISearchContext) => React.ReactNode;
}

export const LiveFilters: React.FC<ILiveFiltersProps> = ({
  flexBoxColWidth,
  fieldColClass,
  standardFilters,
  orFilters,
}) => {
  const context = useSearch();

  return (
    <>
      <div
        className={`grow w-full ${flexBoxColWidth} grid items-center gap-5 my-3 entry-filters entry-search-standard grid-cols-2 ${fieldColClass}`}
      >
        {standardFilters && standardFilters(context)}
      </div>
      {orFilters && (
        <div className="w-full md:w-auto md:border-l my-3 ml-5 flex shrink justify-end items-center entry-filters entry-search-or">
          <span className="text-3xl px-5 text-composite-text not-italic">
            {"OR"}
          </span>
          {orFilters(context)}
        </div>
      )}
    </>
  );
};

export default LiveFilters;
